import classnames from 'classnames';
import { PureComponent } from 'react';

import { MessageWidget } from '../messageWidget';
import { MessageWidgetInput } from '../messageWidgetInput';
import { MessageWidgetOption } from '../messageWidgetOption';

import styles from './widgetPreview.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Message text */
  message: string;
  /** Input data (for input action) */
  input?: {
    label: string;
    placeholder: string;
  };
  /** Options (for menu action) */
  options?: Array<string>;
};

export class WidgetPreview extends PureComponent<PropsT> {
  render() {
    const { className, message, input, options, ...otherProps } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    return (
      <div {...otherProps} className={rootClass}>
        <span className={styles.headline}>Preview</span>
        <MessageWidget markup={message} className={styles.item} />
        {!!input && (
          <MessageWidgetInput
            className={styles.item}
            label={input.label}
            placeholder={input.placeholder}
          />
        )}
        {!!options &&
          options.map((option: string) => (
            <MessageWidgetOption
              className={styles.item}
              key={option}
              text={option}
            />
          ))}
      </div>
    );
  }
}
